// Trophy / title detail content — sourced from the original Framer site.

export const TROPHY_DETAILS = [
  {
    slug: "bombonera-campeon-2020-2021",
    year: "2020/21",
    season: "Pandemia",
    title: "Bombonera Campeón en Pandemia",
    cat: "Liga Local",
    date: "Enero 2021",
    cover:
      "https://framerusercontent.com/images/8SjNIDhmbAEz2PefDQ4o1too.jpeg?width=1600",
    headline: "¡Campeones en Barcelona ⭐⭐⭐⭐!",
    intro:
      "Y por fin llegó el cuarto título en 6 años de La Bombonera. En un año complicadísimo, fuera de lo normal, donde la pandemia afectó todo, el equipo logra volver a coronarse campeón, sobreponiéndose a todos los obstáculos que aparecieron en el camino.",
    paragraphs: [
      "Esto es más que una copa, es la lucha de un grupo de jugadores (de todos los equipos del club), del staff que peleó siempre para apoyar y resolver cualquier adversidad, y también del entrenador que supo gestionar un grupo que fue de menos a más y termina gritando campeón.",
      "Nombrar a todos es imposible, pero nombrar a un grupo que lo dejó todo sí lo es: La Bombo 🙌",
      "Se terminó la temporada, nos iremos de vacaciones a descansar, y a la vuelta volveremos más fuertes en nuestra nueva casa para buscar nuevos títulos y seguir creciendo 🔥",
      "¡Salud campeón! 💯",
    ],
    images: [
      "https://framerusercontent.com/images/5m9lTzLVguaEikBgWz8FUKtg.jpeg",
      "https://framerusercontent.com/images/xNKvpIUGpu6CcpJwtLMqnas3ZHQ.jpeg",
    ],
  },
  {
    slug: "cd-la-bombonera-futbol7b",
    year: "2017/18",
    season: "Apertura · Clausura",
    title: "C.D. La Bombonera Futbol 7B",
    cat: "Categoría F7B",
    date: "Diciembre 2017",
    cover:
      "https://framerusercontent.com/images/rpw1KnGnLrpZ8Ggk55YAnEzBC8.jpg?width=1600",
    headline: "La Bombonera de Barcelona F7B",
    intro:
      "Torneo Apertura 2017-2018: Campeón 2ª División · Torneo Clausura 2017-2018: Subcampeón 1ª División.",
    paragraphs: [
      "Enero 2018, después de una liga de ida extraordinaria que hizo a la Bombonera F7B ganadora, el equipo, desafortunadamente, sufrió un periodo de bajón en el que la mayoría de los fichados se tuvieron que marchar por diferentes motivos personales.",
      "El técnico Roberto, con la ayuda del staff, supo trabajar con los jugadores que quedaban y fundirlos con los nuevos fichajes de invierno. Argentina, Italia, Colombia, Perú, Escocia, Alemania, Chile, Uruguay: 8 países, 8 ideas diferentes de fútbol, pero todos con un mismo objetivo común: ¡ganar!",
      "Así que entreno tras entreno, fuera con lluvia, viento o incluso con nieve, cada uno supo alcanzar sus límites y superarlos. No todos los partidos fueron fáciles, pero el día miércoles 18 de Julio, la Bombonera se proclamó campeón otra vez. Comprometerse con mucho sacrificio, esfuerzo y compañerismo hicieron que los chicos de la Bombonera F7B lograran lo que nunca se hubieran esperado.",
      "Enhorabuena Bombonera. Enhorabuena Mister Roberto. ¡A por un año más, a por otros desafíos!",
    ],
    plantilla: [
      "1 — TonyDaniel",
      "2 — Gustavo",
      "4 — Aitor",
      "5 — Wladimir",
      "6 — James",
      "7 — Alejandro",
      "8 — Michele",
      "9 — Felipe",
      "10 — Diego",
      "11 — Thomas",
      "13 — Dani",
      "15 — Camilo",
      "16 — Mathias",
    ],
    credit: "Redacción: Michele Di Nunzio",
  },
  {
    slug: "la-bombonera-f7a-2017-2018",
    year: "2017/18",
    season: "Apertura",
    title: "La Bombonera F7A — Campeón",
    cat: "Liga F7A",
    date: "Diciembre 2017",
    cover:
      "https://framerusercontent.com/images/qLhiCTLYOyp81zvwiX94eOECDY.jpg?width=1600",
    headline: "La Bombonera F7A — Temporada 2017/2018",
    intro:
      "Termina una temporada espectacular para el equipo de La Bombonera F7A: Campeón en el primer torneo y Subcampeón en el segundo. Liga Apertura: Campeón · Liga Clausura: Subcampeón.",
    paragraphs: [
      "Un conjunto que jugaba su tercera temporada en el club logrando seguir siendo protagonista en todos los torneos que disputó.",
      "Felicitaciones a los jugadores que defendieron esta camiseta y se comprometieron a llevar bien arriba los colores del club.",
    ],
    images: [
      "https://framerusercontent.com/images/jg48V9D3ebJDzPfT1uCxEjR5M.jpg",
      "https://framerusercontent.com/images/Nl3yafIu2Eg0Kgn3iH5G2VyMyo.jpg",
    ],
    plantilla: [
      "1 — Cesar Simón",
      "2 — Elías Figueroa",
      "3 — Enrique Giovine",
      "4 — Bruno Dagna",
      "5 — Ernesto Goñi",
      "6 — Gustavo Gimenez",
      "7 — Ermerson Figueroa",
      "8 — Nico Díaz",
      "9 — Mariano Aiani",
      "10 — Gonzalo Castro",
      "11 — Thomas Oetzel",
      "12 — Arnol Palacios",
      "13 — Daniel Labarca",
      "15 — William Pedrozo",
      "16 — Jairo Gutierrez",
      "99 — Lucas Pecoraro",
      "DT — Nelson Dos Reis",
    ],
  },
  {
    slug: "copa-intercontinental-bcn-2017",
    year: "2017",
    season: "Final",
    title: "Copa Intercontinental BCN",
    cat: "Copa Internacional",
    date: "Noviembre 2017",
    cover:
      "https://framerusercontent.com/images/7IX192OFCzKYFIVte4MulDTiU.jpg?width=1600",
    headline: "¡CAMPEONES Copa Intercontinental BCN 2017!",
    intro:
      "C.D. La Bombonera 6 — 1 Federación del Real Madrid. Una copa más para las vitrinas del club en su segundo año de existencia.",
    paragraphs: [
      "Enfrente, la Selección de Peñas del Real Madrid de Catalunya, a quien se le ganó con contundencia, solidez y fútbol. Un partido complicado en el cual el equipo se encontró con un gol tempranero marcado por el todo terreno BRUNO. Acto seguido, tras un centro, GONZALO la peleó entre dos defensores y marcó por arriba del arquero el 2-0.",
      "10 minutos de juego y parecía aquella final de Japón. No todo fue tan fácil: a partir de ahí el Madrid comenzó a jugar, tuvo varias ocasiones en donde el MURO respondió bien, y con la solidez defensiva de ELIAS y KIKE se aguantó el resultado.",
      "En la segunda parte el equipo tuvo refresco e ideas. Tras un centro de ELIAS, el motor del equipo NICO DIAZ pudo cabecear y, tras el rebote, marcar el 3-0. Ahí el Madrid apretó más, pero tras una buena jugada entre ELIAS y MATIAS, GONZALO cruzó la derecha para el 4-0. La intensidad no bajó: un disparo desde fuera acortó al 4-1, y NICO DIAZ con un derechazo cruzado puso el 5-1. NICO CIANA volvía de una larga lesión y, tras su centro, GONZALO marcó de cabeza el definitivo 6-1.",
      "Un equipo que se empezó a formar hace 2 años y que siempre puso por bandera los valores del Club: humildad, trabajo, seriedad, esfuerzo, lucha, entrega y respeto. 2 copas en 2 años: eso denota la calidad humana y futbolística que hay en este vestuario.",
      "Gracias a todos los que asistieron a apoyar desde afuera. Esto es una familia bien bostera, unida y con mucho para dar. ¡Salud campeón!",
    ],
    plantilla: [
      "1 — Cesar",
      "3 — Kike",
      "7 — Nico C",
      "8 — Nico D",
      "9 — Santiago",
      "10 — Gonzalo",
      "11 — Elías",
      "12 — Matías",
      "18 — Bruno",
      "DT — Miky",
    ],
    scorers: ["Gonzalo × 3", "Nico D × 2", "Bruno × 1"],
  },
  {
    slug: "copa-barcelona-2016",
    year: "2016",
    season: "Final",
    title: "Copa de Barcelona",
    cat: "Copa Regional",
    date: "Noviembre 2016",
    cover:
      "https://framerusercontent.com/images/46Ka2OjWA8rDM8ShwXtINFVuiv0.jpeg?width=1600",
    headline: "¡CAMPEONES de la Copa de Barcelona 2016!",
    intro:
      "Las mejores fotos de la final, en una noche histórica, donde por primera vez en Barcelona un conjunto de Boca obtiene un título en la ciudad.",
    paragraphs: [
      "Se compitió con más de 100 equipos de toda la ciudad, distribuidos en varios complejos. Y sin lugar a dudas la frutilla del postre fue estar en la fase de grupos con la Filial de River de Barcelona, a quien derrotamos por 5-3 obteniendo la paternidad sobre el eterno rival.",
      "Una copa durísima, disputada en diferentes puntos de la ciudad, en la que participaron más de 100 equipos. Nosotros dimos la talla: dejamos atrás a un campeón regional con una hegemonía de 6 ligas seguidas y, por supuesto, al eterno rival, la filial de River. Pero esto no es liga: es copa. Y estos colores sacan la mística necesaria para ganar en las noches mágicas donde nos sentimos más grandes que los demás.",
      "Hay que agradecer a todos: a la gente que se hizo cargo de este proyecto que nació hace 1 año, a los jugadores que se comprometieron y a aquellos que dieron su granito de arena. Ya se viene la primera estrella en el logo y la camiseta.",
      "¡Dale campeón, dale campeón…!",
    ],
    plantilla: [
      "1 — Cesar Simón",
      "3 — Kike Giovine",
      "5 — Ernesto Goñi",
      "6 — Nélson Dos Reis Gomes",
      "7 — Nico Ciana",
      "8 — Nicolás Díaz De Paoli",
      "9 — Mariano Coco Aiani",
      "10 — Gonzalo Ezequiel Castro",
      "11 — Elías Figueroa",
      "12 — Lucas Pecoraro",
      "18 — Mauro de Malena",
      "DT — Miky",
    ],
  },
];

export const findTrophyBySlug = (slug) =>
  TROPHY_DETAILS.find((t) => t.slug === slug);
